$(function(){

    var $htmlbody = $( 'html, body' );

    // --------------------
    // 一十一トップページプロモーション
    // --------------------
    var $role = $( '.ichitoiTopPromotionRole' );
    if ( $role.length ) {
        var $floating =     $role.find( '.floatingImageRole' );
        var $floatingItem = $floating.find( '.item' );

        // 慣性スクロール時にトッププロモーション終端で止める準備
        var scrollObserveFlag = true;// 慣性スクロール監視フラグ
        var scrollStopline = $role.height() + parseInt($role.css('margin-bottom'), 10);// 慣性スクロールをストップする位置（次のブロックが画面トップにくる位置）
        //console.log(scrollStopline, $role.height(), parseInt($role.css('margin-bottom'), 10));

        // scrollendイベントを持つブラウザかどうか判定（iOSはscrollend無し）
        var chk_scrollend = 'onscrollend' in window;
        //alert(chk_scrollend);
        
        // 初期処理
        init();

        // fn:初期処理
        function init(){
            // 表示開始
            $role.addClass( 'ready' );
            // プロモーション画像を順次表示
            $floatingItem.each(function(i){
                var $item = $(this);
                var timer = 1000 + Math.sqrt(i) * 1000;// 順次遅らせて表示するが徐々に早くしたい
                //console.log(i, timer);
                setTimeout(function(){
                    $item.addClass( 'ready' );
                }, timer);
            });
        }

        // イベント：スクロール
        $(window).on('scroll init', function(){
            // ※タイマーを入れてイベント発火頻度を制限したい所ですが動きがぎこちなくなるのであえて入れません
            //console.log('scroll');
            var _scroll = $(window).scrollTop();

            // プロモーション画像の移動
            $floatingItem.each(function(){
                var $this = $(this);
                // 遠くにあるほど画像は小さく移動量も小さい
                var depth = $this.data( 'depth' );
                var coef = 0.3;// 移動量のかかり具合。1未満で指定。１で大きく動き0に近づくほど動きは減少
                var amount = _scroll * coef;
                var move = amount * (1 - depth) * -1;
                $this.css( 'transform', 'translateY(' + move + 'px)' );
            });

            // 表示領域を超えたかどうか
            var outside = scrollStopline - window.innerHeight;// scrolltopline（プロモーションエリア高さ＋下余白）がスクロールアウトして画面を出たライン
            //console.log('スクロール量', _scroll, '領域外判定値', outside);
            if ( _scroll >= outside ) {
                //console.log('エリア外');
                $role.removeClass( 'ready' );
            } else {
                //console.log('エリア内');
                $role.addClass( 'ready' );
                // 慣性スクロール監視フラグON
                scrollObserveFlag = true;
            }

            // 慣性スクロール監視
            inertiaScrollObserve(_scroll);

        }).triggerHandler('init');

        /* debug
        var $debug = $('<div id="debug" style="position:fixed;bottom:0;left:0;font-size:8px;color:#777;"></div>');
        $('body').append($debug);
        */

        // 慣性スクロール監視
        function inertiaScrollObserve(_scroll) {
            // フラグ確認
            if ( !scrollObserveFlag ) {
                return false;
            }

            //console.log(scrollStopline, _scroll, scrollObserveFlag);

            // スクロールが進んで、次のブロックの位置に到達してしまった場合
            if ( scrollStopline <= _scroll) {
                //console.log('スクロールを停止');
                //$('#debugBlock').css('background-color','orange');
                //$debug.html(`${scrollStopline}/${_scroll}`);

                // スクロールしていく様を見せないためのbody要素のscroll不可制御
                $htmlbody.css('overflow', 'hidden');
                //console.log('body要素のscroll不可制御');
                // 場合によってはbody要素のscroll不可が働いたままで一切スクロールできなくなる事もあるので解除タイマーを用意しておきます
                // ※再現方法：自動スクロールボタンで次ブロック位置までスクロールした後にブラウザ更新で発生
                clearTimeout(window.bodyOverflowHiddenTimer)
                window.bodyOverflowHiddenTimer = setTimeout(function(){
                    if ( $htmlbody.css('overflow') == 'hidden' ) {
                        $htmlbody.css('overflow', 'auto');
                        //console.log('body要素のscroll不可制御をタイマーにて解除');
                    }
                }, 1000);

                // ichitoi次ブロックのふわり表示を解除
                $( '.ichitoiCollectionEventRole' ).removeClass('appearEffect');

                // 一応、次ブロックの頭位置までスクロールしておきます
                $( window ).scrollTop( scrollStopline );

                // scrollendイベントを持つデバイスか否かで処理分岐
                if ( chk_scrollend ) {
                    // スクロール終了イベント
                    $(window).on('scrollend', fnScrollEnd);
                } else {
                    // scrollendイベントを持たないデバイス（iOS）
                    // タイマーでスクロール停止を監視（参考：https://qiita.com/degudegu2510/items/586d2713c30a3ef9b312）
                    clearTimeout(window.scrollEndTimer)
                    window.scrollEndTimer = setTimeout(fnScrollEnd, 100);
                }

                // スクロールエンド時の処理
                function fnScrollEnd() {
                    //$('#debugBlock').css('background-color','green');
                    // body要素のscroll制御を解除
                    $htmlbody.css('overflow', 'auto');

                    // スクロール終了イベントを破棄（scrollendイベントを持つ場合）
                    if ( chk_scrollend ) {
                        $(window).off('scrollend', fnScrollEnd);
                    }

                    // スクロール監視フラグをOFF
                    scrollObserveFlag = false;
                }
            }
        }

        // スクロールボタンによるスクロール（2段階スクロール）
        $('.scrollToBottom').on('click', function(){
            $('html').animate({ scrollTop: $role.height() }, {
                duration: 1500,
                easing: 'swing',
                queue: false,
                complete: function(){
                    //console.log('animate終了');
                    setTimeout(function(){
                        $('html').animate({ scrollTop: scrollStopline }, 500);
                        // スクロール監視フラグをOFF
                        scrollObserveFlag = false;
                    }, 1000);
                }
            });
        });
    }



    // --------------------
    // 一十一ページに必要なfunction
    // --------------------

    // ブロックを表示領域に入ったらふわりと表示
    if ( "IntersectionObserver" in window ) {

        // Intersection obsererの作成
        let options = {
            root: null,
            // 各ターゲット要素の高さはそれぞれなので、閾値thresholdは0としておき、rootMarginで一律固定量がブラウザ表示領域に入ったらとします
            rootMargin: '-25% 0px',
            threshold: 0
        };
        let appearEffectObserver = new IntersectionObserver( appearCheck, options );

        function appearCheck( entries, observer ) {
            //console.log('appearCheck', entries, observer);
            entries.forEach(function( entry ) {
                if ( entry.isIntersecting ) {
                    let $entryTarget = $( entry.target );
                    //console.log('appearCheck - IN', $entryTarget);
                    if ( $entryTarget.hasClass('appearEffectCustom') ) {
                        $entryTarget.addClass( 'is-appearCustom' );
                    } else {
                        $entryTarget.addClass( 'is-appear' );
                    }
                    observer.unobserve( entry.target );
                }
            });
        }

        // 監視される要素ターゲット
        var targets = [].slice.call(document.querySelectorAll( '.appearEffect, .appearEffectCustom' ));
        targets.forEach(function( entryTarget ) {
            appearEffectObserver.observe( entryTarget );
        });

    } else {
        // IE11ではサポートされません
        //console.log('Intersection Observer APIがありません');
        $( '.appearEffect' ).addClass( 'is-appear' );
        $( '.appearEffectCustom' ).addClass( 'is-appearCustom' );
    }

});